import axios from "axios";

export const agent = axios.create({timeout: 60000})